import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Checkout() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      setItems(JSON.parse(localStorage.getItem("dz_cart") || "[]"));
    } catch {
      setItems([]);
    }
  }, []);

  const subTotal = useMemo(
    () => items.reduce((a, it) => a + (it.unitPrice || 0) * (it.qty || 0), 0),
    [items]
  );
  const advance = Math.round(subTotal * 0.1 * 100) / 100;
  const remaining = Math.max(subTotal - advance, 0);

  return (
    <div className="max-w-5xl mx-auto px-4 py-6">
      <meta name="robots" content="noindex, nofollow" />
      <div className="flex items-center gap-2 mb-4">
        <button onClick={() => navigate(-1)} className="px-3 py-1.5 border rounded-lg hover:bg-gray-50">
          ← Back
        </button>
        <button onClick={() => navigate("/store")} className="px-3 py-1.5 border rounded-lg hover:bg-gray-50">
          🏪 Continue shopping
        </button>
      </div>

      <h1 className="text-2xl font-extrabold mb-6">Checkout</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Address / details */}
        <div className="md:col-span-2 space-y-4">
          <div className="bg-white border rounded-xl p-4">
            <h2 className="font-semibold mb-3">Contact & Address</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <input className="border rounded px-3 py-2" placeholder="Full name" />
              <input className="border rounded px-3 py-2" placeholder="Phone number" />
              <input className="border rounded px-3 py-2 md:col-span-2" placeholder="Address line" />
              <input className="border rounded px-3 py-2" placeholder="City" />
              <input className="border rounded px-3 py-2" placeholder="Pincode" />
            </div>
          </div>

          <div className="bg-white border rounded-xl p-4">
            <h2 className="font-semibold mb-3">Items</h2>
            <div className="space-y-2">
              {items.map((it) => (
                <div key={it.key} className="flex justify-between text-sm">
                  <div className="truncate">
                    {it.title} <span className="text-gray-500">({it.color})</span> × {it.qty}
                  </div>
                  <div>₹{(it.unitPrice || 0) * (it.qty || 0)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Summary / payment */}
        <aside className="bg-white border rounded-xl p-4 h-fit">
          <h2 className="font-semibold mb-3">Payment</h2>
          <div className="flex justify-between py-1">
            <span>Subtotal</span>
            <span>₹{subTotal}</span>
          </div>
          <div className="flex justify-between py-1">
            <span>Advance (10%)</span>
            <span className="text-green-700 font-semibold">₹{advance}</span>
          </div>
          <div className="flex justify-between py-1">
            <span>Pay on Delivery</span>
            <span>₹{remaining}</span>
          </div>

          {/* Buttons (Razorpay integration baad me) */}
          <button
            className="mt-4 w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg"
            onClick={() => alert("Payment gateway integrate karenge (Razorpay). Abhi demo ke liye order placed maana jaayega.")}
          >
            Pay ₹{advance} Now (10%) & Place Order
          </button>

          <p className="text-xs text-gray-500 mt-2">
            10% abhi online, baaki ₹{remaining} delivery par COD.
          </p>
        </aside>
      </div>
    </div>
  );
}
